type ListingPhotoItem = {
    url: string;
    mimeType?: string | null;
};

function canonicalUrl(url: string) {
    try {
        return new URL(url).href;
    } catch {
        return url;
    }
}

export function collectListingPhotoItems(input: {
    media: Array<{ url?: string | null; mimeType?: string | null }>;
    imageUrls?: Array<string | null | undefined>;
    listingPageImages?: Array<{ url?: string | null }>;
}): ListingPhotoItem[] {
    const seen = new Set<string>();
    const items: ListingPhotoItem[] = [];
    const add = (url: string | null | undefined, mimeType?: string | null) => {
        if (!url) return;
        const key = canonicalUrl(url);
        if (seen.has(key)) return;
        seen.add(key);
        items.push(mimeType ? { url, mimeType } : { url });
    };
    for (const item of input.media) add(item.url, item.mimeType);
    for (const url of input.imageUrls ?? []) add(url);
    for (const image of input.listingPageImages ?? []) add(image.url);
    return items;
}
